import {useLocation} from "react-router-dom";

const useQueryParams = (key: string) => {
    const useQuery = () => new URLSearchParams(useLocation().search);
    let queryParam = useQuery();

    return queryParam.get(key)
}

export default useQueryParams